export default __webpack_public_path__ + "static/media/notFoundIcon.91ab6626.svg";